import { useAuth } from "@clerk/react";
import { Navigate, Outlet, useLocation } from "react-router";
import { LoadingState } from "@/components/states";

/**
 * UX guard only. The API authorizes every request on the server
 * (api-contract.md §1), so this never decides who may see data.
 */
export function RequireAuth() {
  const { isLoaded, isSignedIn } = useAuth();
  const location = useLocation();

  if (!isLoaded) return <LoadingState label="Checking your session" />;
  if (!isSignedIn) {
    const back = encodeURIComponent(`${location.pathname}${location.search}`);
    return <Navigate to={`/sign-in?redirect_url=${back}`} replace />;
  }
  return <Outlet />;
}
